import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@client/components/ui/dialog';
import DiffJsonViewer from './JsonDifferenceViewer';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { JsonViewer } from './JsonViewer';

interface FormDataComparatorDialogProps {
  submissionData: any;
  docuSignData: any;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FormDataComparator: React.FC<FormDataComparatorDialogProps> = ({
  submissionData,
  docuSignData,
  open,
  onOpenChange,
}) => {
  const [tab, setTab] = useState<'view' | 'diff'>('view');

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="flex max-h-[80vh] max-w-5xl flex-col p-6">
        <DialogHeader className="mb-4 flex items-center justify-between">
          <DialogTitle className="text-black">Docusign Data Comparison</DialogTitle>
        </DialogHeader>

        <Tabs
          value={tab}
          onValueChange={v => setTab(v as 'view' | 'diff')}
          className="flex flex-1 flex-col overflow-hidden"
        >
          <div className="mb-2">
            <TabsList className="inline-flex w-auto">
              <TabsTrigger value="view">View</TabsTrigger>
              <TabsTrigger value="diff">Difference</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent
            value="view"
            className="flex flex-1 overflow-hidden"
          >
            <div className="flex flex-1 gap-4 overflow-hidden">
              <div className="flex min-w-0 flex-1 flex-col">
                <JsonViewer
                  data={submissionData}
                  title="Submission Data"
                  key="submission"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <JsonViewer
                  data={docuSignData}
                  title="Docusign Data"
                  key="docusign"
                />
              </div>
            </div>
          </TabsContent>

          <TabsContent
            value="diff"
            className="flex flex-1 overflow-hidden"
          >
            <DiffJsonViewer
              baseData={submissionData}
              baseDataTitle="Submission Data"
              compareData={docuSignData}
              compareDataTitle="Docusign Data"
            />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
